import { Dispatch } from "redux"
import { DisplaySettingAction, DisplaySettingsActionType } from "../types/displaySettings"
import { sortEnum } from "../../types/types"
import { dataRepresentationEnum } from "../../../../types/customers"

const setBestArr = (bestArr: number[]) => {
  return (dispatch: Dispatch<DisplaySettingAction>) => {
    dispatch({
      type: DisplaySettingsActionType.SET_BEST_ARR,
      payload: bestArr,
    })
  }
}

const setFieldName = (fieldName: string) => {
  return (dispatch: Dispatch<DisplaySettingAction>) => {
    dispatch({
      type: DisplaySettingsActionType.SET_FIELD_NAME,
      payload: fieldName,
    })
  }
}

const setSortType = (sortType: sortEnum) => {
  return (dispatch: Dispatch<DisplaySettingAction>) => {
    dispatch({
      type: DisplaySettingsActionType.SET_SORT_TYPE,
      payload: sortType,
    })
  }
}

const setSelectedCampaignIds = (selectedCampaignIds: number[]) => {
  const selectedUniqCampaignIds = new Set(selectedCampaignIds)

  return (dispatch: Dispatch<DisplaySettingAction>) => {
    dispatch({
      type: DisplaySettingsActionType.SET_SELECTED_CAMPAIGN_IDS,
      payload: [...selectedUniqCampaignIds],
    })
  }
}

const setExpandableCampaignIds = (expandableCampaignIds: number[]) => {
  const uniqExpandableCampaignIds = [...new Set(expandableCampaignIds)]

  return (dispatch: Dispatch<DisplaySettingAction>) => {
    dispatch({
      type: DisplaySettingsActionType.SET_EXPANDABLE_CAMPAIGN_IDS,
      payload: uniqExpandableCampaignIds,
    })
  }
}

const setDataRepresentation = (dataRepresentation: dataRepresentationEnum) => {
  return (dispatch: Dispatch<DisplaySettingAction>) => {
    dispatch({
      type: DisplaySettingsActionType.SET_DATA_REPRESENTATION,
      payload: dataRepresentation,
    })
  }
}

const setSelectedOptions = (selectedOptions: string[]) => {
  return (dispatch: Dispatch<DisplaySettingAction>) => {
    dispatch({
      type: DisplaySettingsActionType.SET_SELECTED_OPTIONS,
      payload: selectedOptions,
    })
  }
}

const setPerPage = (perPage: number) => {
  return (dispatch: Dispatch<DisplaySettingAction>) => {
    dispatch({
      type: DisplaySettingsActionType.SET_PER_PAGE,
      payload: perPage,
    })
  }
}

const setPageNo = (pageNo: number) => {
  return (dispatch: Dispatch<DisplaySettingAction>) => {
    dispatch({
      type: DisplaySettingsActionType.SET_PAGE_NO,
      payload: pageNo,
    })
  }
}

export default {
  setBestArr,
  setFieldName,
  setSortType,
  setSelectedCampaignIds,
  setExpandableCampaignIds,
  setDataRepresentation,
  setSelectedOptions,
  setPerPage,
  setPageNo,
}
